module.exports = __webpack_public_path__ + "static/img/amg-energia-1.5d7a0e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/amg-energia-1.jpg
// module id = s7HP
// module chunks = 1